// removed by extract-text-webpack-plugin
module.exports = {"orgnizerList":"orgnizerList__1uSHA","orgnizer":"orgnizer__32Gzs"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Organizers/index.css
// module id = 1370
// module chunks = 0